const sieveCache = new Map<number, number[]>();

export function sieve(limit: number): number[] {
  if (limit < 2) return [];
  const cached = sieveCache.get(limit);
  if (cached !== undefined) return cached.slice();
  const composite = new Uint8Array(limit + 1);
  const primes: number[] = [];
  for (let i = 2; i <= limit; i += 1) {
    if (composite[i] === 0) {
      primes.push(i);
      for (let j = i * i; j <= limit; j += i) {
        composite[j] = 1;
      }
    }
  }
  sieveCache.set(limit, primes);
  return primes.slice();
}

export function isPrime(n: number): boolean {
  if (!Number.isInteger(n) || n < 2) return false;
  if (n < 4) return true;
  if (n % 2 === 0) return false;
  const limit = Math.floor(Math.sqrt(n));
  for (let i = 3; i <= limit; i += 2) {
    if (n % i === 0) return false;
  }
  return true;
}

export function nextPrime(n: number): number {
  let candidate = Math.floor(n) + 1;
  if (candidate < 2) candidate = 2;
  while (!isPrime(candidate)) {
    candidate += 1;
  }
  return candidate;
}
